module.exports = __webpack_public_path__ + "static/media/user.c1b444d9.png";